import Button from "~/components/ui/Button"
import { getGridTemplateColumns } from "../helpers/GridTemplateConstant"
import { UserTableRowProps } from "../interfaces/UserTableRowProps"

const UserTableRow = ({ user, handleUserClick, isIdenticalCamps }: UserTableRowProps) => {
  return (
    <div
      className="grid hover:bg-gray-200 cursor-pointer relative"
      style={{
        gridTemplateColumns: getGridTemplateColumns(isIdenticalCamps),
        transition: "all .3s",
        minWidth: 840,
      }}
      onClick={() => {
        handleUserClick(user)
      }}
    >
      <div
        className="font-medium text-md text-gray-900 flex items-center gap-4 border-t py-5 px-2 truncate"
        key={user?.id}
      >
        {user?.email}
      </div>
      <div className="font-medium text-md flex items-center border-t px-2 text-gray-475">{user?.full_name}</div>
      <div className="font-medium text-md flex items-center border-t px-2">
        <div className="text-gray-475">{user.role[0].toUpperCase() + user.role.slice(1)}</div>
      </div>
      {!isIdenticalCamps && (
        <div className="font-medium whitespace-nowrap text-md flex items-center justify-between gap-3 border-t px-2 text-gray-475">
          <div className="flex flex-col gap-0.25 max-h-20 overflow-y-auto overflow-x-hidden w-full max-w-full">
            {user.camps.map((camp) => (
              <div className="">{camp.name}</div>
            ))}
          </div>
        </div>
      )}
      <div className="border-t flex items-center justify-end pr-3">
        <Button
          variant="none"
          onClick={(e) => {
            e.preventDefault()
          }}
          className="p-1 h-full rounded-3xl text-base font-medium transition-colors text-blue-650 underline"
          children={"Edit"}
          style={{ padding: 0 }}
        />
      </div>
    </div>
  )
}

export default UserTableRow
